export default {
  heading: count => `${count} Applied Filter${count !== 1 ? 's' : ''}`
}
